module.exports = __webpack_public_path__ + "images/preview_grey@3x.png?21e273b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_grey@3x.png
// module id = 685
// module chunks = 7